export default {
  tabTitle: 'Model Composer',
  composeModel: 'Compor modelo',
  intro: 'Monte um modelo com canais dos seus modelos existentes.',
  search: 'Buscar',
  noModels: 'Ainda não há modelos compostos',
  headerName: 'Nome',
  headerCountry: 'País',
  headerQuality: 'Qualidade',
  headerCreated: 'Criado',
  headerCreatedBy: 'Criado por',
  headerStatus: 'Status',
  statusBuilding: 'Em construção',
  statusReady: 'Pronto',
  viewReport: 'Ver relatório',
  printJson: 'Imprimir JSON no console',
  deleteModel: 'Excluir modelo',
  deleteDialogTitle: 'Excluir modelo?',
  deleteDialogText: '{name} será excluído. Você poderá recuperá-lo durante 7 dias solicitando a um administrador.',
  deleteDialogTextBuilding: '{name} será excluído permanentemente.',
  cancel: 'Cancelar',
  delete: 'Excluir',
  close: 'Fechar',
  idCopied: 'ID copiado para a área de transferência',
  snackDeleted: 'Modelo excluído',
  snackErrorDeleting: 'Erro ao excluir o modelo',
  relNow: 'agora',
  relMinutes: '{n} min',
  relHours: '{n} h',
  relDays: '{n} d',
  relMonths: '{n} mês | {n} meses',
  relYears: '{n} ano | {n} anos'
}
